let date = new Date();
date.setFullYear(date.getFullYear() + 1);
export default {
  Number: '',
  IssueDate: new Date().toStringRu(),
  StartDate: new Date().toStringRu(),
  EndDate: date.toStringRu(),
  ContragentId: '',
  PartnerLegalId: '',
  ContragentName: '',
  ContragentType: '',
  OwnerLegalEntityId: '',
  CurrencyId: 1,
  Type: 2,
  IsPayed: false,
  IsUsed: false,
  Sum: 0,
  Balance: 0,
  Id: '',
  CreatorName: '',
  Comment: '',
  ParentNumber: '',
  PartnerId: 0,
  UsersSum: 0,
  CreateDate: '',
  SumOld: 0,
  options: {
    legals: [],
  },
  rules: {
    Number: [
      {required: true, message: 'Введите номер сертификата', trigger: 'blur,change'},
    ],
    ContragentId: [
      {required: true, message: 'Выберите покупателя', type: 'number', trigger: 'blur,change'},
    ],
    Sum: [
      {required: true, min: 1, message: 'Введите сумму сертификата', type: 'number', trigger: 'blur'},
    ],
    OwnerLegalEntityId: [
      {required: true, message: 'Выберите фирму-владелеца', type: 'number', trigger: 'blur,change'},
    ],
    IssueDate: [
      {required: false, message: 'Введите', trigger: 'blur,change'},
    ],
    StartDate: [
      {required: false, message: 'Введите', trigger: 'blur,change'},
    ],
    EndDate: [
      {required: false, message: 'Введите', trigger: 'blur,change'},
    ],
    Type: [
      {required: false, message: 'Введите', trigger: 'blur,change'},
    ],
  }
}
